import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import AddResourceCharge from "../modals/AddResourceCharge";
import Table from "../reusable_components/Table";
import AddMaterialList from "../modals/AddMaterialList";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnGreen, btnRed, title, btnOneNoWidth } from "../utils/style";
import edit from '../assets/icons/edit.png'
import deleteIcon from '../assets/icons/delete.png'
import ConfirmationModal from "../reusable_components/ConfirmationModal";
import formatNumberToUs from "../custom_functions/formatNumberToUs";
import { convertMinToHour } from "../utils/dateTime";


function MaterialList() {
    const [ showAndModifyAddMaterial, setShowAndModifyAddMaterial ] = useState(false);
    const [ materialData, setMaterialData ] = useState()
    const [ deleteId, setDeleteId ] = useState(null)
    const [ reloadTable, setReloadTable ] = useState(false)

    function toggleModify(data) {
        setMaterialData(data);
        setShowAndModifyAddMaterial(true)
    }

    async function deleteMaterial() {
        try {
            const reqUrl = url + '/services/material_list/' + deleteId;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.delete(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
            console.log(data);
            reloadTable(1 + Math.random())
        } catch (error) {
            toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
            console.log(error)
        } finally {
            setDeleteId(null)
        }
    }

    const options = [
        {
            header: 'Part Name',
            key: 'name',
        },
        {
            header: 'Part Cost',
            render: (data) => {
                return(
                    `$${formatNumberToUs(data.cost?.toFixed(2))}`
                )
            },
            filterKey: 'cost'
        },
        {
            header: 'Estimated Time',
            key: 'estimatedTime',
            render: (data) => { return convertMinToHour(data.estimatedTime) },
        },
        {
            header: 'Cost Type',
            key: 'costType',
        },
        {
            header: 'Action',
            render: (data) => {
                return(
                    <>
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => toggleModify(data)}
                        >
                            <img src={edit} height={15} width={15} />
                        </button>
                        <button 
                            className={'bg-customOne p-2 rounded-full mr-4'}
                            onClick={() => setDeleteId(data.id)}
                        >
                            <img src={deleteIcon} height={15} width={15} />
                        </button>
                    </>
                )
            }
        }
    ]

    const excludeFilter = ['Action']

    return(
        <div className="p-4">
            {
                showAndModifyAddMaterial && <AddMaterialList materialData={materialData} reload={setReloadTable} setMaterialData={setMaterialData} setShowModal={setShowAndModifyAddMaterial} />
            }
            {
                deleteId && <ConfirmationModal title={'Part'} setShowForm={setDeleteId} confirm={deleteMaterial} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Parts List</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Part`} clickHandler={() => setShowAndModifyAddMaterial(!showAndModifyAddMaterial)} />
                )}
            </div>
            
            <Table 
                options={options} 
                url={url + '/services/material_list'} 
                pagination 
                clickHandler={() => setShowAndModifyAddMaterial(!showAndModifyAddMaterial)}
                btnTitle={'Part'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default MaterialList;